import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { track, events } from 'src/configs/amplitude';
import { Button, TextField, Typography } from '@mui/material';
import { AddressElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import { sleep } from 'src/utils/sleep';
import useStyles from './styles';
export const StripeForm = observer(_ref => {
  let isAwaitProcess = _ref.isAwaitProcess,
    setIsAwaitProcess = _ref.setIsAwaitProcess;
  const store = useStore();
  const stripe = useStripe();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const elements = useElements();
  const navigate = useNavigate();
  const page = 'Paygate';
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    coupon = _useState2[0],
    setCoupon = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    invalidCoupons = _useState4[0],
    setInvalidCoupons = _useState4[1];
  const postCoupon = async () => {
    const resp = await store.payment.postSetupIntentWithCouponAsync.run({
      promotionCode: coupon,
      setupIntentId: store.payment.stripeSetupIntentId
    });
    return resp;
  };
  const handleSubmit = async event => {
    event.preventDefault();
    store.account.setIsSavingPaygate(true);
    if (coupon) {
      let isCouponValid = true;
      await postCoupon().then(resp => {
        if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) {
          isCouponValid = false;
          setInvalidCoupons([...invalidCoupons, coupon]);
        }
      });
      if (!isCouponValid) {
        store.account.setIsSavingPaygate(false);
        return;
      }
    }
    setIsAwaitProcess(true);
    if (!stripe || !elements) {
      toast('error', {
        body: ['Stripe error']
      });
      setIsAwaitProcess(false);
      store.account.setIsSavingPaygate(false);
      return;
    }
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {},
      redirect: 'if_required'
    });
    if (result.error) {
      toast('error', {
        body: [result.error.message]
      });
      setIsAwaitProcess(false);
      store.account.setIsSavingPaygate(false);
      return;
    }
    for (let count = 0; count < 10; count++) {
      const isPaymentMethodsAsync = await store.payment.getPaymentMethodsAsync.run();
      if (isPaymentMethodsAsync !== null && isPaymentMethodsAsync !== void 0 && isPaymentMethodsAsync.response && isPaymentMethodsAsync !== null && isPaymentMethodsAsync !== void 0 && isPaymentMethodsAsync.response.length) {
        break;
      } else {
        if (count === 9) toast('error', {
          body: ['Stripe error']
        });
      }
      await sleep(5000);
    }
    await store.company.getCurrentUserCompanyFromTokenAsync.run();
    await store.portfolios.getPortfoliosDashboardAsync.run({
      storeCompany: true
    });
    await store.portfolios.getExistingPortfoliosAsync.run();
    track(events.signedUp(), {
      page
    });
    setIsAwaitProcess(false);
    store.account.setIsSavingPaygate(false);
    navigate('/active_dashboard');
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(AddressElement, {
    options: {
      mode: 'billing'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(PaymentElement, {
    options: {
      layout: {
        type: 'accordion',
        defaultCollapsed: false,
        radios: true,
        spacedAccordionItems: false
      },
      paymentMethodOrder: ['us_bank_account']
    }
  })), !store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xlSection, " ").concat(classes.couponSection, " ").concat(classes.subSection)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('subscriptions.code_for_discount')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('subscriptions.only_one_discount'))), /*#__PURE__*/React.createElement(TextField, {
    className: "".concat(classes.couponSection),
    error: invalidCoupons.includes(coupon),
    fullWidth: true,
    helperText: invalidCoupons.includes(coupon) && 'This coupon code is invalid. Please check and try again.',
    id: "coupon",
    label: t('subscriptions.enter_code_here'),
    name: "Coupon",
    onChange: e => {
      if (e.target.value.length <= 255) setCoupon(e.target.value);
    },
    onBlur: () => track(events.filled('Coupon'), {
      page
    }),
    type: "text",
    value: coupon,
    variant: "outlined"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isAwaitProcess,
    fullWidth: true,
    type: "submit",
    variant: "priority",
    onClick: () => track(events.clicked('Submit Billing Info'), {
      page
    }),
    'custom-attribute': '702-paygate-loader-page'
  }, t('sign_up_flow.submit_information'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isAwaitProcess
  }));
});